<div class="form-item" [ngClass]="'form-field-'+field.type">
  <div class="form-field-menu">
    <core-helpers-navigation-three-dots-menu
      [menu]="fieldMenu"
      (action)="onMenuClick($event)"
    ></core-helpers-navigation-three-dots-menu>
  </div>
  <div [ngClass]="{'invalid-field': field.label == ''}">
    <input type="text" [ngModel]="field.label" [placeholder]="placeholder" (ngModelChange)="onFieldChange($event)">
  </div>
  <div class="field-mandatory">
    <core-helpers-forms-input-checkbox
      [label]="'Make field mandatory'"
      [defaultChecked]="field.mandatory"
      [form]="form"
      (checkedChange)="onMandatoryChange($event)"
    ></core-helpers-forms-input-checkbox>
  </div>
</div>